<template>
  <section>
    <div v-if="questions.length > 0" class="p-4 flex flex-col gap-8">
      <div
        class="flex flex-col w-full bg-white p-4 pb-8 rounded-b-md border-b-4 border-h-primary-500 py-4 min-h-[100px] gap-8 shadow-md"
        v-for="(question, i) in questions"
        :key="i"
      >
        <div class="w-full flex justify-between">
          <div class="w-[80%]">
            <p class="font-[800]">{{ question?.prompt }}</p>
          </div>
          <div class="flex justify-center items-center gap-2">
            <p>
              {{ $t("labels.generic", { pt: "Questão: ", en: "Question: " }) }}
            </p>
            <div
              class="bg-h-secondary-200 flex justify-center items-center p-1 px-4 rounded-xl text-h-secondary-900"
            >
              Fechada
            </div>
          </div>
        </div>
        <div
          class="flex flex-col gap-4 lg:flex-row"
          v-for="(item, j) in question.items"
          :key="j"
        >
          <div
            class="w-full lg:w-[25%] min-w-[200px] flex flex-row-reverse lg:flex-row justify-end lg:justify-start items-center"
          >
            <div class="w-[30px] h-[40px] flex items-center justify-center">
              <v-icon
                name="hi-solid-check-circle"
                class="text-[#74B543]"
                v-if="item.correct"
              ></v-icon>
            </div>
            <p class="line-clamp-2">{{ item.name }}</p>
          </div>
          <div class="w-full flex flex-col gap-8">
            <div
              class="h-[40px] w-full bg-h-neutral-200 rounded-md overflow-auto overflow-x-hidden"
            >
              <div
                v-if="item.count && item.count > 0"
                :class="`flex justify-end p-4 items-center h-[40px] w-[${item.percentage}%] ${item.background}  rounded-l-md`"
                :style="`width:${item.percentage}%`"
              >
                <p class="text-sm" v-if="item.percentage > 17">{{ item.count }} ({{ item.percentage }}%)</p>
              </div>
              <div
                class="w-full h-[40px] flex items-center p-4"
                v-if="item.choseTimes === 0 || item.percentage < 17"
              >
                <p class="text-sm">{{ item.percentage }}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <EmptyData
        :data="questions.length == 0"
        :title="`${$t('labels.generic', {
          pt: 'Dados não encontrados',
          en: 'titleEN',
        })}`"
        :label="`${$t('labels.generic', {
          pt: 'Os dados gerados pelas perguntas feitas pelo chat Homero ficarão aqui.',
          en: 'titleEN',
        })}`"
        :image="'waiting_object.svg'"
        imgSize="h-40"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "quizChat",
  data() {
    return {};
  },
  props: {
    questions: {
      type: Array as PropType<any>,
      default: [],
    },
  },
  mounted() {
    this.createItems();
  },
  methods: {
    getBackground(idItem: any, idCorrectAnswer: any): string {
      let result = "bg-h-error-400 text-white";
      if (idItem === idCorrectAnswer) {
        result = "bg-[#74B543] text-black";
      }
      return result;
    },
    createItems(): void {
      this.questions.forEach((element) => {
        element.items = [
          {
            name: this.$t("labels.generic", {
              pt: "Acertaram",
              en: "Corrects",
            }),
            count: element.correctCount,
            percentage: element.correctPercent,
            background: "bg-[#74B543] text-black",
            correct: true,
          },
          {
            name: this.$t("labels.generic", {
              pt: "Erraram",
              en: "Incorrects",
            }),
            count: element.incorrectCount,
            percentage: element.incorrectPercentage,
            background: "bg-h-error-400 text-white",
            correct: false,
          },
          {
            name: this.$t("labels.generic", {
              pt: "Não responderam",
              en: "Not answered",
            }),
            count: element.notAnsweredCount,
            percentage: element.notAnsweredPercentage,
            background: "bg-h-neutral-900 text-white",
            correct: false,
          },
        ];
      });
    },
  },
});
</script>
